import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { ProtocolVersionResponse } from "../../models/dtos";
import { Button } from "primereact/button";
import { protocolsApi } from "../../services/protocols/protocolsApi";

interface ProtocolVersionsListProps {
  protocolId: number;
  protocolVersions: ProtocolVersionResponse[];
}

const ProtocolVersionsList = ({ protocolId, protocolVersions }: ProtocolVersionsListProps) => {
  const [createProtocolVersion, { isLoading: isCreateProtocolVersionLoading }] =
    protocolsApi.useCreateProtocolVersionMutation();

  return (
    <Card title="Версии на протокола" className="shadow-4">
      <DataTable value={protocolVersions} stripedRows>
        <Column field="version" header="Версия" style={{ width: "80px" }} />
        <Column
          field="createDate"
          header="Дата на създаване"
          style={{ width: "150px" }}
          body={(rowData) => new Date(rowData.createDate).toLocaleDateString("bg-BG")}
        />
        <Column field="userFullName" header="Създадена от" />
        <Column
          field="protocolSignature.signatureDate"
          header="Дата на подпис"
          style={{ maxWidth: "150px" }}
          body={(rowData) =>
            rowData.protocolSignature?.signatureDate
              ? new Date(rowData.protocolSignature.signatureDate).toLocaleDateString("bg-BG")
              : ""
          }
        />
        <Column
          field="protocolSignature.signature"
          header="Подпис"
          style={{ width: "200px" }}
          pt={{
            bodyCell: {
              style: {
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            },
          }}
          body={(rowData) => rowData.protocolSignature?.signature || ""}
        />
        <Column
          field="protocolSignature.userFullName"
          header="Подписано от"
          body={(rowData) => rowData.protocolSignature?.userFullName || ""}
        />
      </DataTable>
      <div className="flex justify-content-end mt-4">
        <Button
          label="Създай нова версия"
          icon="pi pi-plus"
          loading={isCreateProtocolVersionLoading}
          onClick={() => createProtocolVersion(protocolId)}
        />
      </div>
    </Card>
  );
};

export default ProtocolVersionsList;
